/**
 * Derives the attribute diff of an activity log row from its `properties`.
 *
 * The server used to append Spatie's `changes` accessor, which is literally
 * `properties->only(['attributes', 'old'])` -- a second copy of nearly the whole
 * `properties` blob on every row. It is derived here instead.
 *
 * Both keys are always present, which ChangesModal relies on: it reads
 * `changes.attributes` and `changes.old` unguarded. Defaulting `old` to an empty
 * object also fixes rows logged by a `created` event, which carry `attributes`
 * with no `old` and used to throw when the modal was opened.
 *
 * @param {Object} item activity log row
 * @returns {{attributes: Object, old: Object}}
 */
export function activityLogChanges (item) {
    return {
        attributes: item.properties?.attributes ?? {},
        old: item.properties?.old ?? {}
    }
}

/**
 * Whether a row has an attribute diff worth opening the changes modal for.
 *
 * Exactly equivalent to the old `Object.keys(item.changes).length > 0`. It must
 * not be relaxed to a check on `properties` as a whole: `properties` also carries
 * the placeholder payload written by ActivityObserver (brand_id, language, name,
 * segments, free_months), which the subject route mapping reads, so rows with
 * placeholders but no diff would offer a modal with nothing in it.
 *
 * @param {Object} item activity log row
 * @returns {boolean}
 */
export function hasActivityLogChanges (item) {
    return item.properties?.attributes !== undefined || item.properties?.old !== undefined
}
